import { combineReducers, configureStore } from "@reduxjs/toolkit";
import articleFrontReducer from "./article";
import authFrontReducer from "./auth";
import ourServiceFrontReducer from "./otherServices";
import contactUsFrontReducer from "./contactUs";
import homeSectionFrontReducer from "./homeSection";

import languageFrontReducer from "./language";

import cmsFrontReducer from "./cms";
import otherServiceFrontReducer from "./otherServices";
import publicationFrontReducer from "./publication";
import promotionFrontReducer from "./promotion";
import creditSegementFrontReducer from "./creditSegmentCode";

import orderRequestsAdminReducer from "./orderRequests";
import orderReviewsAdminReducer from "./orderReviews";
import creditLimitRequestAdminReducer from "./creditLimitRequests";
import chatAdminReducer from "./chat";
import returnSalesOrderFrontReducer from "./returnSalesOrder";
import notificationReducer from "./notification";
import sapConfigFrontReducer from "./sapConfig";
import salesOrderRequisitionConfigReducer from "./salesOrderRequisitionConfig";
import expiryReturnConfigReducer from "./expiryReturnConfig";
import dashboardFrontReducer from "./dashboard";
import roleReducer from "./role";
import permissionReducer from "./permission";
import contactInfoFrontReducer from "./contactInfo";
import localizationFrontReducer from "./localization";
import staffReducer from "./staff";

const rootReducer = combineReducers({
  orderRequests: orderRequestsAdminReducer,
  orderReviews: orderReviewsAdminReducer,
  creditLimitRequests: creditLimitRequestAdminReducer,
  chat: chatAdminReducer,
  roles: roleReducer,
  permissions: permissionReducer,

  cms: cmsFrontReducer,
  otherService: otherServiceFrontReducer,
  publication: publicationFrontReducer,
  promotion: promotionFrontReducer,
  article: articleFrontReducer,
  auth: authFrontReducer,
  ourService: ourServiceFrontReducer,
  contactUs: contactUsFrontReducer,
  homeSection: homeSectionFrontReducer,
  language: languageFrontReducer,
  creditSegmentCode: creditSegementFrontReducer,
  returnSalesOrder: returnSalesOrderFrontReducer,
  notification: notificationReducer,
  sapConfig: sapConfigFrontReducer,
  salesOrderRequisitionConfig: salesOrderRequisitionConfigReducer,
  expiryReturnConfig: expiryReturnConfigReducer,
  dashboard: dashboardFrontReducer,
  contactInfo: contactInfoFrontReducer,
  localization: localizationFrontReducer,
  staff: staffReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
